
import React, { useContext, useEffect, useState } from 'react';
import '../../App.css';
import { Redirect, withRouter, Link } from "react-router-dom";
import { url } from '../../utils';
// import heroImage1 from '../../viblica_illustration.png'
import heroImage2 from '../../assets/images/undraw_videographer_nnc7.svg'
// import heroImage3 from '../../assets/images/undraw_taking_selfie_lbo7.svg'
import { Empty, Form } from "antd";
import { StreamItemBase, StreamItemBasePreview } from './LiveEventsHero';
import LoadingCards from '../LoadingCards';
import LoadingVideoCards from '../LoadingVideoCards';
import environments from '../../environments';
import GlobalStateContext from '../../context';
import StreamWebService from '../../classes/StreamWebService';
import { LiveEventItem } from './LiveEvents';
import CategoryTiles from '../CategoryTiles';



export function Event({ item }) {
  const { streamingServer } = environments.app.api;
  const { live } = streamingServer.apps
  const [state,] = useContext(GlobalStateContext);

  const [color, setColor] = useState(["green", "danger", "warning"][item.status]);
  const isPremium = item.ppv_value > 0.00;
  const { user, stream_destinations } = state;
  // const _itemLink = (!!user || isPremium) ? url(`stream/${item.id}/watch`, true) : url(`${item.id}/watch`, false)
  const _itemLink = (!!user || isPremium) ? url(`stream/${item.id}/watch`, true) : url(`${item.id}/watch`, false)
  const snapshot = item.image;


  return (
    <Link to={_itemLink}>

      {/* <StreamItemBase item={item} /> */}
      <StreamItemBasePreview item={item} />



    </Link>
  )
}



export function EventsCatalogue({ onReady, user_id }) {
  const itemsPerPage = 15;
  const [overallCount, setOveralCount] = useState(0);
  var itemsSet = 1;
  const [state, setstate] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const webs = new StreamWebService();
  const [payload, setPayload] = useState({
    page: itemsSet, perPage: itemsPerPage,
    user: user_id
  });
  const getPublicEvents = () => {
    setIsLoading(true)

    webs.getCategorizedStream(payload)
      .then(res => res.data)
      .then(data => {

        setstate(data);
        onReady && onReady(data);
      })

      .finally(_ => setIsLoading(false));
  }


  const cleanup = () => setstate([]);
  useEffect(() => {
    getPublicEvents();
  }, [payload])
  useEffect(() => {
    getPublicEvents()
    return cleanup
  }, [])


  return (
    <div className="relative flex items-end px-6 py-4 sm:py-6 md:py-8 lg:py-12 bg-gray-700 sm:px-8 lg:pb-24 lg:px-10 xl:pl-12 col-span-3">


      <div className="relative h-full w-full mx-auto lg:max-w-none">
        <CategoryTiles onClick={cat => { setPayload({ ...payload, category: cat }) }} />
        {
          state.upcoming?.length > 0 &&
          <div className=' sm:my-2 md:my2 lg:my-5'>

            <p className="  text-lg md:text-xl lg:text-3xl font-bold text-white"> Upcoming </p>

            <div className="grid grid-cols-2 sm:grid-cols-3 md md:grid-cols-4 lg:grid-cols-6  mt-6 gap-x-5 gap-y-5 ">

              {
                state.upcoming.map(item => <Event item={item} key={item.id} />)

              }

            </div>
          </div>
        }
        <div className=' sm:my-2 md:my2 lg:my-5'>
          <p className="  text-lg md:text-xl lg:text-3xl font-bold text-white">Popular </p>


          {isLoading
            ?
            <LoadingVideoCards dark={true} />
            :
            <div className="grid grid-cols-2 sm:grid-cols-3 md md:grid-cols-4 lg:grid-cols-6  mt-6 gap-x-5 gap-y-5 ">
              {state.popular?.length > 0
                ?
                state.popular.map(item => <Event item={item} key={item.id} />)
                :
                <Empty />}
            </div>
          }




        </div>
        <div className='mx-2'>
          <p className="  text-lg md:text-xl lg:text-3xl font-bold text-white"> Recent </p>


            {isLoading
              ?
              <LoadingVideoCards dark={true} />
              :
          <div className="grid grid-cols-2 sm:grid-cols-3 md md:grid-cols-4 lg:grid-cols-6  mt-6 gap-x-5 gap-y-5 ">
             { state.recently_created?.length > 0
                ?
                state.recently_created.map(item => <Event item={item} key={item.id} />)
                :
                <Empty />}
          </div>
            }


        </div>



      </div>
    </div>

  )
}


function Events(props) {

  const [heroMessage, setHeroMessage] = useState({});
  const [heroImage, setHeroImage] = useState("");
  const [email, setEmail] = useState("");


  useEffect(() => {

  }, [])
  return (
    <div className="relative">

      <section className="relative bg-gray-900 py-0">

        <div className="relative mx-auto max-w-8xl lg:grid lg:grid-cols-3">

          <EventsCatalogue />

        </div>
      </section>
    </div>


  )
}


export default Events